import React, { useState, useEffect } from "react";
import { Modal } from 'react-bootstrap';
import { Network } from '../../component/network/network';
import { baseUrl } from '../../component/network/url';
import Navbar from 'react-bootstrap/Navbar';
import './navigationBar.css?v=2.1';
import logoDark from '../../assets/home/gardifyLogoDark.png';
import logoLight from '../../assets/gardifyLogoLight.svg';

const NavigationBar = () => {
  const [expanded, setExpanded] = useState(false);

  const handleToggle = () => setExpanded(!expanded);

  const network = Network();
  const [email, setEmail] = useState('');
  const [modalMessage, setModalMessage] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    if (expanded) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, [expanded])

  const handleSubscribe = async () => {

    if (!email || email.trim().length > 3) {
      setLoading(true);
      network.postRequest(`${baseUrl}AccountAPI/newsletter?email=${email}`)
        .then((data) => {
          setModalMessage(data ?? "An error occurred");
          setLoading(false);
          setShowModal(true);
          setEmail('');

        })
        .catch((error) => {
          setLoading(false);
          setModalMessage(error || 'Fehler');
        });

    }
  };

  const handleClose = () => {
    setShowModal(false);
  };

  return (<>
    <Navbar expanded={expanded} className="custom-navbar shadow" expand="lg" fixed="top">
      <>
        <Navbar.Brand className={`${expanded ? 'isOpen' : ''}`}>
          <a href="https://gardify.de/">
            <img src={logoLight} alt="logo light" height={40} className="logo-light" />
            <img src={logoDark} alt="logo dark" height={50} className="logo-dark"
            />
          </a>
        </Navbar.Brand>
      </>

    </Navbar>
    <Modal show={showModal} onHide={handleClose} centered bottom style={{ zIndex: '999999999999999999999' }}>
      <Modal.Body className='d-flex justify-content-between' style={{ backgroundColor: modalMessage === 'Fehler' ? '#ffcccc' : '#e7f6ec' }}>
        {modalMessage}
        <button type="button" className="btn-close" aria-label="Close" onClick={handleClose}></button>
      </Modal.Body>
    </Modal>
  </>

  );
};

export default NavigationBar;
